// store/modules/ui.js
export default {
  namespaced: true,

  state: () => ({
    openSideConfig: false,
    sideConfigMap: {}, // { [key]: data }
  }),

  mutations: {
    OPEN_SIDECONFIG(state) {
      state.openSideConfig = true;
    },
    CLOSE_SIDECONFIG(state) {
      state.openSideConfig = false;
    },

    SET_SIDE_CONFIG(state, { key, data }) {
      state.sideConfigMap = {
        ...state.sideConfigMap,
        [key]: data,
      };
    },

    CLEAR_SIDE_CONFIG(state, key) {
      const { [key]: _, ...rest } = state.sideConfigMap;
      state.sideConfigMap = rest;
    },
  },

  actions: {
    async GET_SIDECONFIG({ commit, dispatch }, key) {
      const response = await dispatch("keyValue/LOAD_HOME_NOTIFICATION", { key }, { root: true });
      commit("SET_SIDE_CONFIG", { key, data: response.config ? JSON.parse(response.config) : "" });
      return response;
    },

    async SAVE_SIDECONFIG({ commit, dispatch }, { key, config }) {
      const response = await dispatch(
        "keyValue/SAVE_HOME_NOTIFICATION",
        {
          key,
          config,
        },
        { root: true }
      );
      commit("SET_SIDE_CONFIG", { key, data: response.config ? JSON.parse(response.config) : "" });
      return response;
    },
  },
};
